import React, { useEffect, useState } from 'react'
import { useUser } from '../context/user'
import { deleteById, getMyPrivateNotes } from '../server/server'
import { format_day, datesAreOnSameDay, notify } from '../utils/util'
import { ReactComponent as NoteLockIcon } from '../svg/normalSvgs/NoteLockIcon.svg'
import { ReactComponent as AngleUpIcon } from '../svg/normalSvgs/AngleUpIcon.svg'
import '../styles/NewPrivateNotes.css'
import { decrypt } from '../utils/crypto'
import { useTranslation } from 'react-i18next'
import { camelCase } from 'lodash'
import NewSecretKeyModal from './Modal/NewSecretKeyModal'
import ConfirmationModal from './Modal/ConfirmationModal'
import { useToasts } from 'react-toast-notifications'

const moodQuestions = {
    Worse: 'sorryToHearThatThingsAreWorseWhichOfTheFollowingWouldHelpRightNow',
    'Much worse': 'feelingMuchWorseQuestion',
    Same: 'feelingSameQuestion',
    Better: 'feelingBetterQuestion',
    'Much better': 'greatToHearThingsAreMuchBetterAndThinkAboutHowToImproveEvenMoreOrKeepItOnAPositiveLevel',
}

function NewPrivateNotes() {
    const secretKey = localStorage.getItem('secret_key')
    const { user } = useUser()
    const { t } = useTranslation()
    const [notes, setNotes] = useState([])
    const [secretKeyModalIsOpen, setSecretKeyModalOpen] = useState(!secretKey)
    const [selectedIndex, setSelectedIndex] = useState([])
    const [deleteNoteConfirm, setDeleteNoteConfirm] = useState(false)
    const [noteId, setNoteId] = useState('')
    const [noteIndex, setNoteIndex] = useState(-1)
    const { addToast } = useToasts()

    const closeModal = () => setSecretKeyModalOpen(false)
    const closeConfirmModal = () => {
        setDeleteNoteConfirm(false)
    }

    const loadNotes = async () => {
        const resp = await getMyPrivateNotes()
        if (resp.status === 200) {
            const results = resp.data
            setNotes(results.data)
        }
    }

    useEffect(() => {
        loadNotes()
    }, [])

    const openNote = (index) => {
        let newArray = selectedIndex
        if (!selectedIndex.includes(index)) {
            setSelectedIndex([...selectedIndex, index])
            return
        } else {
            let newIndex = selectedIndex.indexOf(index)
            if (newIndex > -1) {
                newArray.splice(newIndex, 1)
            }
            setSelectedIndex([...newArray])
        }
    }
    const deleteNote = (id, index) => {
        setDeleteNoteConfirm(true)
        setNoteId(id)
        setNoteIndex(index)
    }
    const execute_deletion = async () => {
        const resp = await deleteById({ collection: 'private_notes', id: noteId })
        if (resp.status === 200) {
            openNote(noteIndex)
            loadNotes()
            setDeleteNoteConfirm(false)
            addToast(t('noteHasBeenDeleted'), {
                appearance: 'success',
                autoDismiss: true,
            })
        }
    }

    const NotePreview = ({ note, index }) => {
        return (
            <div className="new-note-preview">
                <div className="new-note-item" onClick={() => openNote(index)} style={{ backgroundColor: selectedIndex.includes(index) ? '#ECEBF8' : '#f8f8fb' }}>
                    <div className="new-note-title-container">
                        <p className="new-note-item-type">{note.type === 'day_reflection' ? t('dailyReflection') : (decrypt(note.name, secretKey) ?? t('dailyFeedback'))}</p>

                        <p className="new-note-item-date">{format_day(note.created_date)}</p>
                    </div>
                    <div className="new-note-select" style={{ transform: selectedIndex.includes(index) ? 'rotate(180deg)' : 'none' }}>
                        <AngleUpIcon />
                    </div>
                </div>
                {selectedIndex.length !== 0 && selectedIndex.includes(index) && note.type === 'daily_feedback' && (
                    <div className="new-note-opened">
                        <p className="new-note-opened-subtitle">{t('doYouThinkThingsAreForAnyReasonInParticular', { result: t(camelCase(note.compare)).toLowerCase() })}</p>
                        <div className="new-note-compare-answer">
                            <p className="new-note-compare-message">{decrypt(note.message, secretKey)}</p>
                        </div>
                        <p className="new-note-opened-subtitle" style={{ marginTop: 21 }}>
                            {t(moodQuestions[note.compare])}
                        </p>
                        <div className="note-suggestions">
                            {note.suggestions.map((suggestion, index) => {
                                return (
                                    <div className="new-note-suggestion-item" key={index}>
                                        <p className="new-note-suggestion-text">
                                            0{index + 1} {decrypt(suggestion, secretKey)}
                                        </p>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="new-note-delete" onClick={() => deleteNote(note.id, index)}>
                            <p>{t('deleteNote')}</p>
                        </div>
                    </div>
                )}
                {selectedIndex.includes(index) && note.type === 'day_reflection' && (
                    <div className="new-note-opened">
                        <p className="new-note-opened-subtitle">{t('whatAreJust3GoodThingsThatHappenedToday')}</p>
                        <div className="note-suggestions" style={{ marginTop: 5 }}>
                            {note.things_happened_today.map((suggestion, index) => {
                                return (
                                    <div className="new-note-suggestion-item" key={index}>
                                        <p className="new-note-suggestion-text">
                                            0{index + 1} {decrypt(suggestion, secretKey)}
                                        </p>
                                    </div>
                                )
                            })}
                        </div>
                        <p className="new-note-opened-subtitle" style={{ marginTop: 20 }}>
                            {t('whatAre3ThingsThatAreABitChallengingAtTheMoment')}
                        </p>
                        <div className="note-suggestions" style={{ marginTop: 5 }}>
                            {note.challenging_things.map((suggestion, index) => {
                                return (
                                    <div className="new-note-suggestion-item" key={index}>
                                        <p className="new-note-suggestion-text">
                                            0{index + 1} {decrypt(suggestion, secretKey)}
                                        </p>
                                    </div>
                                )
                            })}
                        </div>
                        <p className="new-note-opened-subtitle" style={{ marginTop: 20 }}>
                            {t('whatsJustOneThingYouWillDoDifferentlyTomorrow')}
                        </p>
                        <div className="new-note-compare-answer" style={{ marginTop: 10 }}>
                            <p className="new-note-compare-message">{decrypt(note.tomorrow_plan, secretKey)}</p>
                        </div>
                        <div className="new-note-delete" onClick={() => deleteNote(note.id, index)}>
                            <p>{t('deleteNote')}</p>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    return (
        <div id="profileid" className="new-notes-container shadow-custom-soft">
            <p className="new-notes-title">{t('yourPrivateNotes')}</p>
            <div className="new-notes-subtitle">
                <NoteLockIcon />
                <p className="new-notes-text"> {t('thisIsYourSafePlaceAndNothingWillBeShared')}</p>
            </div>
            {notes.map((note, index) => {
                const previousNote = index > 0 && notes[index - 1]
                const previousNoteDay = previousNote?.created_date
                const sameDay = !!previousNoteDay && datesAreOnSameDay(new Date(note.created_date), new Date(previousNoteDay))

                return (
                    <div key={index} className="new-notes-group">
                        {!sameDay && (
                            <div className="new-notes-dates" style={{ direction: 'ltr' }}>
                                {format_day(note.created_date)}
                            </div>
                        )}
                        <NotePreview note={note} index={index} />
                    </div>
                )
            })}

            <NewSecretKeyModal modalIsOpen={secretKeyModalIsOpen} closeModal={closeModal} elementId={'profileid'} />
            <ConfirmationModal
                modalIsOpen={deleteNoteConfirm}
                closeModal={closeConfirmModal}
                message={t('confirmDeletion')}
                subMessage={t('Delete your private note?')}
                confirmation={execute_deletion}
            />
        </div>
    )
}

export default NewPrivateNotes
